import { FormConfig } from '@lbcamden/lib-react';
import { z } from 'zod';

import { whatToDoNextSchema } from '~/common/schemas/pcfra';

export type WhatToDoNextFormValues = z.infer<typeof whatToDoNextSchema>;

export const whatToDoNextFormConfig: FormConfig<WhatToDoNextFormValues> = {
  fieldConfigs: {
    hasCompletedAllActions: {
      label:
        'Have all the necessary actions above been taken to ensure the safety of the resident?',
      radioOptions: [
        { id: 'yes', label: 'Yes, all actions have been completed', value: true },
        { id: 'no', label: 'No, additional action required', value: false },
      ],
    },
  },
};
